// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface PassphraseExportStatus {
  exported: boolean;
  exported_at: string | null;
  exported_by: string | null;
}

interface ActionResponse {
  message: string;
  [key: string]: any;
}

class PassphraseService {

  async regenerateAll(accessToken: string): Promise<ActionResponse> {
    const response = await fetch(`${API_BASE_URL}/admin/passphrases/regenerate-all`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    const json = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }

    return json;
  }

  // Passphrase déchiffrée d'un groupe (route ouverte aux membres du groupe, teachers et admins)
  async getGroupPassphrase(groupId: number, accessToken: string): Promise<string | null> {
    const response = await fetch(`${API_BASE_URL}/project-groups/${groupId}/passphrase`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
    });

    const json = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }

    return json.passphrase ?? null;
  }

  async getExportStatus(accessToken: string): Promise<PassphraseExportStatus> {
    const response = await fetch(`${API_BASE_URL}/admin/passphrases/export-status`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async downloadPassphrasesExcel(accessToken: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/admin/passphrases/export-xlsx`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${accessToken}`
      },
    });

    if (!response.ok) {
      const json = await response.json().catch(() => ({}));
      throw new Error(json.message || `HTTP error! status: ${response.status}`);
    }

    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'passphrases_groupes.xlsx';
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }
}

export const passphraseService = new PassphraseService();
